import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { emojiQQ } from '@/const/emojiMap';
import { debounce } from 'lodash';
import { mapState } from 'vuex';
var imui = null;
export default {
  meta: {
    title: '客服中心',
    auth: true,
    cache: true
  },
  name: 'chat',
  data: function data() {
    return {
      emojiQQ: emojiQQ,
      initData: {
        width: '100%',
        height: '100%',
        hideMessageTime: true,
        hideMessageName: true,
        simple: true
      },
      user: {},
      nextSeq: 0,
      conversationList: [],
      currentChatId: '',
      chatLogs: [],
      end: false,
      lastMsgId: null,
      propr: false,
      videoSrc: '',
      dialogVisible: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('d2admin', {
    isImFormId: function isImFormId(state) {
      return state.message.isImFormId;
    },
    userInfo: function userInfo(state) {
      return state.user.info;
    }
  })), {}, {
    TXIM: function TXIM() {
      return YL.txim;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    this.TXIM.$off('MESSAGE_RECEIVED');
    this.TXIM.$off('CONVERSATION_LIST_UPDATED');
    this.TXIM.$off('MESSAGE_READ_BY_PEER');
  },
  methods: {
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.videoUrl = '';
    },
    messageClick: function messageClick(event, key, Message, instance) {
      var type = Message.type,
          content = Message.content;

      switch (type) {
        case 'image':
          this.openImageView(content);
          break;

        case 'video':
          this.videoSrc = Message.videoUrl;
          this.dialogVisible = true;
          break;

        default:
          break;
      }
    },
    clickEmoji: function clickEmoji(item) {
      var val = imui.getEditorValue();
      imui.setEditorValue(val + '' + item);
    },
    handleFocusOut: function handleFocusOut() {
      console.log('关闭了');
      this.propr = false; // do something here
    },
    onProfileUpdated: function onProfileUpdated(e) {
      console.log(e, '监听到好友信息改变');
    },
    onFriendListUpdated: function onFriendListUpdated(e) {
      console.log(e, '监听到好友列表改变');
    },
    onConversationHandler: function onConversationHandler(e) {
      var _this = this;

      console.log(e, '监听会话列表改变');
      var conversationList = e.data.sort(function (a, b) {
        return b.lastMessage.lastTime - a.lastMessage.lastTime;
      });
      this.conversationList = conversationList.map(function (v) {
        return {
          id: v.conversationID,
          displayName: v.userProfile.nick || '联系窗口',
          avatar: v.userProfile.avatar || _this.VUE_APP_ICON_IMG,
          index: '联系人',
          unread: v.unreadCount,
          //最近一条消息的内容，如果值为空，不会出现在“聊天”列表里面。
          //lastContentRender 函数会将 file 消息转换为 '[文件]', image 消息转换为 '[图片]'，对 text 会将文字里的表情标识替换为img标签,
          lastContent: imui.lastContentRender(_this.TXIM.setMessageType(v.lastMessage)),
          //最近一条消息的发送时间
          lastSendTime: v.lastMessage.lastTime * 1000
        };
      });

      if (this.conversationList.length === 0) {
        return;
      }

      imui.initContacts(this.conversationList);
    },
    onRecvMessageHanlderChat: function onRecvMessageHanlderChat(e) {
      console.log(e, '监听到新的消息');
      var V2TIMMessageManager = this.TXIM.getInstance();
      var msg = e.data[0]; //接收者id

      if (msg.conversationID == this.currentChatId) {
        V2TIMMessageManager.markC2CMessageAsRead(this.currentChatId); //将接收到的数据包装成下面的样子

        var data = _objectSpread({
          id: msg.ID,
          status: msg.status,
          sendTime: msg.time * 1000,
          toContactId: msg.conversationID,
          fromUser: {
            //如果 id == this.user.id消息会显示在右侧，否则在左侧
            id: msg.from,
            displayName: msg.nick,
            avatar: msg.avatar || this.VUE_APP_ICON_IMG
          }
        }, V2TIMMessageManager.setMessageType(msg));

        imui.appendMessage(data);
        imui.messageViewToBottom();
      }
    },
    //获取会话列表
    getConversationList: function getConversationList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this2$TXIM$ge, data, conversationList, c2c, is, obj;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.TXIM.getConversationList();

              case 2:
                _yield$_this2$TXIM$ge = _context.sent;
                data = _yield$_this2$TXIM$ge.data;
                data.conversationList = data.conversationList || data.conversations;
                conversationList = data.conversationList.sort(function (a, b) {
                  return b.lastMessage.lastTime - a.lastMessage.lastTime;
                });
                _this2.conversationList = conversationList.map(function (v) {
                  return {
                    id: v.conversationID,
                    displayName: '联系窗口',
                    avatar: v.userProfile.avatar || _this2.VUE_APP_ICON_IMG,
                    index: '联系人',
                    unread: v.unreadCount,
                    //最近一条消息的内容，如果值为空，不会出现在“聊天”列表里面。
                    //lastContentRender 函数会将 file 消息转换为 '[文件]', image 消息转换为 '[图片]'，对 text 会将文字里的表情标识替换为img标签,
                    lastContent: imui.lastContentRender(_this2.TXIM.setMessageType(v.lastMessage)),
                    //最近一条消息的发送时间
                    lastSendTime: v.lastMessage.lastTime * 1000
                  };
                });
                c2c = _this2.isImFormId.indexOf('custom_service') > -1 ? 'C2C' + _this2.isImFormId : 'C2Cu_' + _this2.isImFormId;
                is = _this2.conversationList.some(function (v) {
                  return v.id === c2c;
                });

                if (!is || _this2.conversationList.length === 0) {
                  obj = {
                    id: c2c,
                    displayName: '联系窗口',
                    avatar: _this2.VUE_APP_ICON_IMG,
                    index: '联系人',
                    unread: 0,
                    lastContent: '',
                    //最近一条消息的发送时间
                    lastSendTime: ''
                  };

                  _this2.conversationList.unshift(obj);
                }

                _context.next = 12;
                return _this2.$nextTick();

              case 12:
                imui.initContacts(_this2.conversationList);
                imui.changeContact(c2c);
                imui.messageViewToBottom();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    //获取历史消息
    getLogs: function getLogs() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$_this3$TXIM$ge, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.TXIM.getC2CHistoryMessageList(_this3.currentChatId, 20, _this3.lastMsgId);

              case 2:
                _yield$_this3$TXIM$ge = _context2.sent;
                data = _yield$_this3$TXIM$ge.data;
                _this3.lastMsgId = data.nextReqMessageID;
                _this3.end = data.isCompleted;
                return _context2.abrupt("return", data.messageList);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    toChat: debounce( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(item) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.currentChatId = item.id;
                console.log(this.currentChatId);
                _context3.next = 4;
                return this.TXIM.markC2CMessageAsRead(item.id);

              case 4:
                _context3.next = 6;
                return this.getLogs();

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), 500, {
      leading: true,
      trailing: false
    }),
    // 发送文字
    sendText: debounce( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(text, type, next) {
        var V2TIMMessageManager, currentId, v2TIMMessage;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                V2TIMMessageManager = this.TXIM.getInstance();
                currentId = this.currentChatId.indexOf('custom_service') == -1 ? this.currentChatId.indexOf('u_') == -1 ? 'u_' + this.currentChatId : this.currentChatId : this.currentChatId;
                _context4.next = 4;
                return V2TIMMessageManager.createTextMessage(currentId, text);

              case 4:
                v2TIMMessage = _context4.sent;
                console.log(currentId); // try {

                _context4.next = 8;
                return V2TIMMessageManager.sendMessage(v2TIMMessage);

              case 8:
                setTimeout(function () {
                  next({
                    status: 'success',
                    type: 'textdir',
                    isPeerRead: v2TIMMessage.isPeerRead
                  });
                }, 500); // } catch (e) {
                // this.$message.error('发送失败')
                // }

                _context4.next = 11;
                return this.$nextTick();

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function (_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }(), 500, {
      leading: true,
      trailing: false
    }),
    handleSend: function handleSend(message, next, file) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.sendText(message.content, message.type, next);

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    handlePullMessages: function handlePullMessages(contact, next) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var data, messages;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this5.toChat(contact);

              case 2:
                data = _context6.sent;
                messages = data.map(function (v) {
                  return _objectSpread({
                    id: v.ID,
                    status: v.status,
                    sendTime: v.time * 1000,
                    toContactId: contact.id,
                    fromUser: {
                      id: v.from,
                      displayName: v.nick,
                      avatar: v.avatar || _this5.VUE_APP_ICON_IMG
                    }
                  }, _this5.TXIM.setMessageType(v));
                }); // await this.HistoryMessageToChatLog(data, 'unshift')
                //参数设为true，表示已到末尾，聊天窗口顶部会显示“暂无更多消息”

                next(messages, _this5.end);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    //初始化工具栏
    initTool: function initTool() {
      var _this6 = this;

      var h = this.$createElement;
      // { name: 'uploadFile' }, { name: 'uploadImage' }
      var tool = [];
      var emojiTool = {
        name: 'emojiTool',
        isRight: false,
        title: '选择表情',
        click: function click() {
          _this6.propr = !_this6.propr;
        },
        render: function render() {
          return h("d2-icon-svg", {
            "attrs": {
              "name": "d2-emoji"
            },
            "style": "width:20px;height:26px;fill:#999"
          });
        }
      };
      tool.push(emojiTool);
      imui.initEditorTools(tool);
      var emoji = emojiQQ.map(function (v) {
        return {
          name: v,
          title: v,
          src: ''
        };
      });
      imui.initEmoji(emoji);
      imui.setLastContentRender('video', function (message) {
        return h("span", ["[\u89C6\u9891]"]);
      });
      imui.setLastContentRender('textdir', function (message) {
        return h("span", [message.content]);
      });
    },
    getMyProfile: function getMyProfile() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this7.TXIM.getMyProfile();

              case 2:
                data = _context7.sent;
                _this7.user = {
                  id: data.userID,
                  displayName: data.nick,
                  avatar: data.avatar || _this7.VUE_APP_ICON_IMG
                };

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onReadByPeerHandler: function onReadByPeerHandler(message) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log('收到消息已读回执', message);
                message.data.forEach(function (x) {
                  imui.updateMessage(_objectSpread({
                    id: x.ID
                  }, _this8.TXIM.setMessageType(_objectSpread({}, x))));
                });
                imui.forceUpdateMessage();

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    init: function init() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var IMUI;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this9.currentChatId = _this9.isImFormId;
                _context9.next = 3;
                return _this9.getMyProfile();

              case 3:
                IMUI = _this9.$refs.IMUI;
                imui = IMUI;

                _this9.initTool(); // 监听会话列表的消息


                _this9.TXIM.$on('CONVERSATION_LIST_UPDATED', _this9.onConversationHandler); // 监听新的消息


                _this9.TXIM.$on('MESSAGE_RECEIVED', _this9.onRecvMessageHanlderChat);

                _this9.TXIM.$on('MESSAGE_READ_BY_PEER', _this9.onReadByPeerHandler); // 自己或好友的资料发生变更时触发，event.data 是包含 Profile 对象的数组
                //   this.TXIM.$on('PROFILE_UPDATED', this.onProfileUpdated)
                // 好友列表更新时触发
                //   this.TXIM.$on('FRIEND_LIST_UPDATED', this.onFriendListUpdated)


                _context9.next = 11;
                return _this9.$nextTick();

              case 11:
                _this9.getConversationList();

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    }
  },
  mounted: function mounted() {
    this.init();
  }
};